module.exports = __webpack_public_path__ + "static/img/item-4-2-big.6670a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-4-2-big.png
// module id = KURG
// module chunks = 2